import React, { useEffect, useRef, useState } from 'react'
import { GetVenueQuestions, UpdateVenueCategoryOrder, UpdateVenueQuestionOrder } from '../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';
import { useLocation, useParams } from 'react-router-dom';
import { Box, Button, InputLabel, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setLoadingFalse, setLoadingTrue } from '../../../global/config/Action/loadingActions.ts';
import html2pdf from 'html2pdf.js';
import { Print } from '@mui/icons-material';


function SetVenueQuestionOrder() {
    const location = useLocation();
    // const { venueId, venueName } = location.state || {}
    const {venueId, venueName} = useParams()
    const [questionlist, setQuestionList] = useState<any>([])
    const [selectedOption, setselectedOption] = useState<string>('setquestion')
    const [categorylist, setCategoryList] = useState<any>()
    const [updatedOrder, setUpdatedOrder] = useState<any>([])
    const dispatch = useDispatch()
    const [localValues, setLocalValues] = useState<Record<string, string>>({});
    const [localCategoryValues, setLocalCategoryValues] = useState<Record<string, string>>({});
    const printRef = useRef<HTMLDivElement>(null);


    const handleDirectPrint = () => {
        const element = printRef.current;

        const options = {
            margin: 10,
            filename: 'temp.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).toPdf().get('pdf').then((pdf) => {
            window.open(pdf.output('bloburl'), '_blank');
        });
    };

    const fetchtselectedquestions = async () => {
        try {
            const response = await GetVenueQuestions(venueId)
            setQuestionList(
                response?.data
                    ?.slice() // make a shallow copy (so original data isn’t mutated)
                    ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)
            );
            setUpdatedOrder(
                response?.data
                    ?.slice() // make a shallow copy (so original data isn’t mutated)
                    ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)
                    .map((item: any) => (
                        {

                            clientEntityQuestion_venue_id: item.clientEntityQuestionVenueId,
                            displayOrder: item.displayOrder,
                        }
                    ))
            )
            // const orderArr = response?.categoryDisplayOrderIds.split(",").map(Number);
            // const uniqueCategories = [
            //     ...new Map(
            //         response.data.map(item => [
            //             item.questionId.categoryId.categoryId,
            //             item.questionId.categoryId.categoryName
            //         ])
            //     ).entries()
            // ].map(([id, name]) => ({ categoryId: id, categoryName: name }));

            // const sortedCategories = uniqueCategories.sort((a, b) => {
            //     const indexA = orderArr.indexOf(a.categoryId);
            //     const indexB = orderArr.indexOf(b.categoryId);
            //     if (indexA === -1 && indexB === -1) return 0; // neither in order list
            //     if (indexA === -1) return 1; // a not in order list → push to end
            //     if (indexB === -1) return -1; // b not in order list → keep earlier
            //     return indexA - indexB; // sort by position
            // });

            // setCategoryList(sortedCategories)
            const orderArr = response?.categoryDisplayOrderIds
                ? response.categoryDisplayOrderIds.split(",").map(Number).filter(num => !isNaN(num))
                : [];

            const uniqueCategories = [
                ...new Map(
                    response.data.map(item => [
                        item.questionId.categoryId.categoryId,
                        item.questionId.categoryId.categoryName
                    ])
                ).entries()
            ].map(([id, name], index) => ({
                categoryId: id,
                categoryName: name,
                order: orderArr.indexOf(id) !== -1 ? orderArr.indexOf(id) + 1 : (index + 1)
            }));

            const sortedCategories = uniqueCategories.sort((a, b) => {
                // If order is -1, it means not found in orderArr, push to end
                const orderA = a.order === -1 ? Infinity : a.order;
                const orderB = b.order === -1 ? Infinity : b.order;
                return orderA - orderB;
            });
            setCategoryList(sortedCategories);
        }
        catch (error: any) {
            toast.error(error)
        }
    }
    useEffect(() => {

        fetchtselectedquestions()
    }, [])

    const SaveQuestionOrder = async () => {
        try {
            const data = {
                type: "venue_questions",
                questionOrders: updatedOrder || []
            }
            const res = await UpdateVenueQuestionOrder(data)
            if (res.status) {
                toast.success("Question ordered successfully")
                fetchtselectedquestions()
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }
    const SaveCategoryOrder = async () => {
        try {
            const data = {
                type: "venue_questions",
                venueId: venueId,
                categoryDisplayOrderIds: categorylist?.map((item) => item?.categoryId)?.join(',') || ''
            }
            const res = await UpdateVenueCategoryOrder(data)
            if (res.status) {
                toast.success("Category ordered successfully")
                fetchtselectedquestions()
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }
    const handleSaveOrder = () => {
        if (selectedOption === 'setquestion') {
            SaveQuestionOrder()
        }
        else {
            SaveCategoryOrder()
        }
    }
    const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));

    function reorderByMoving(list: any, id: number, targetOrder: number) {
        const total = list.length;
        const newOrderClamped = clamp(Number(targetOrder), 1, total);
        if (isNaN(newOrderClamped)) return list;

        // make shallow copy
        const copy = [...list];

        // find index of item to move
        const fromIndex = copy.findIndex((x) => x.clientEntityQuestion_venue_id === id);
        if (fromIndex === -1) return list;

        // remove the item
        const [item] = copy.splice(fromIndex, 1);

        // insert at new position (targetOrder is 1-based)
        const toIndex = newOrderClamped - 1;
        copy.splice(toIndex, 0, item);

        // reassign sequential displayOrder starting from 1
        return copy.map((x, idx) => ({
            ...x,
            displayOrder: idx + 1,
        }));
    }

    const handleOrderChange = (id: number, newOrder: number) => {
        setUpdatedOrder((prev) => reorderByMoving(prev, id, newOrder));

        setTimeout(() => {
            const element = document.getElementById(`question-${id}`);
            if (element) {
                // smooth scroll to element
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });

                // add highlight class
                element.classList.add('blink-highlight');

                // remove highlight after 2 seconds
                setTimeout(() => {
                    element.classList.remove('blink-highlight');
                }, 500);
            }
        }, 1000);
        // setUpdatedOrder((prev) => {
        //     const list = [...prev];
        //     const current = list.find((q) => q.clientEntityQuestionVenueId === id);
        //     if (!current || newOrder < 0 || newOrder >= list.length) return list;

        //     const oldOrder = current.displayOrder;

        //     // Update current question's order
        //     current.displayOrder = newOrder;

        //     // Adjust other items
        //     return list.map((q) => {
        //         if (q.clientEntityQuestionVenueId === id) return current;

        //         // When moving down (5 → 2)
        //         if (oldOrder > newOrder && q.displayOrder >= newOrder && q.displayOrder < oldOrder) {
        //             return { ...q, displayOrder: q.displayOrder + 1 };
        //         }

        //         // When moving up (2 → 5)
        //         if (oldOrder < newOrder && q.displayOrder <= newOrder && q.displayOrder > oldOrder) {
        //             return { ...q, displayOrder: q.displayOrder - 1 };
        //         }

        //         return q;
        //     });
        // });
    };
    // console.log("Updated Order List", updatedOrder)

    const handleCategoryOrderChange = async (oldIndex: number, newOrder: number) => {
        dispatch(setLoadingTrue())
        try {
            if (newOrder < 1 || newOrder > categorylist.length) return;
            const updated = [...categorylist];
            const [movedItem] = updated.splice(oldIndex, 1); // remove old
            updated.splice(newOrder - 1, 0, movedItem); // insert at correct (1-based)

            // Reset the order numbers correctly (1-based)
            const reordered = updated.map((item, i) => ({
                ...item,
                order: i + 1,
            }));

            setCategoryList(reordered);
            setTimeout(() => {
                const element = document.getElementById(`category-${movedItem.categoryId}`);
                if (element) {
                    // smooth scroll to element
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    // add highlight class
                    element.classList.add('blink-highlight');

                    // remove highlight after 2 seconds
                    setTimeout(() => {
                        element.classList.remove('blink-highlight');
                    }, 500);
                }
            }, 1000);

        } catch (error) {
            console.log(error)
        }
        finally {
            dispatch(setLoadingFalse())
        }

    };

    return (
        <Box className='h-100 w-100 p-3'>
            <Box className='extra d-flex align-items-center  justify-content-between'>
                <ToggleButtonGroup className='mb-5' sx={{ borderRadius: "10px" }} value={selectedOption} onChange={(e: any) => { setselectedOption(e.target.value) }}>
                    <ToggleButton sx={{ textTransform: "none" }} value={'setquestion'}>
                        Set Question Order
                    </ToggleButton>
                    <ToggleButton sx={{ textTransform: "none" }} value={'setcategory'}>
                        Set Category Order
                    </ToggleButton>
                </ToggleButtonGroup>
                <Button
                    // variant="contained"
                    className='text-white py-1 px-3'
                    startIcon={<Print sx={{ color: 'white' }} />}
                    onClick={handleDirectPrint}
                    sx={{ background: "#ADB792" }}
                >
                    Print Content
                </Button>
            </Box>
            {selectedOption === 'setquestion' ? (
                <Box ref={printRef}>
                    <Typography className=' fw-bold mb-3' variant='h6'>{venueName} (question order)</Typography>
                    
                    {[...questionlist]
                        .sort((a: any, b: any) => {
                            const aOrder =
                                updatedOrder?.find(
                                    (q: any) => q.clientEntityQuestion_venue_id === a.clientEntityQuestionVenueId
                                )?.displayOrder ?? a.displayOrder;

                            const bOrder =
                                updatedOrder?.find(
                                    (q: any) => q.clientEntityQuestion_venue_id === b.clientEntityQuestionVenueId
                                )?.displayOrder ?? b.displayOrder;

                            return aOrder - bOrder;
                        })
                        ?.map((item: any) => (
                            <Box id={`question-${item.clientEntityQuestionVenueId}`} className='p-2 border mb-2 d-flex align-items-center justify-content-between' borderRadius={'10px'}>
                                <Box sx={{ maxWidth: '95%' }}>
                                    <Typography className='px-3 py-1' gutterBottom variant='subtitle2' borderRadius={'10px'} width={'fit-content'} bgcolor={'#ADB7925A'}>{item?.questionId?.categoryId?.categoryName}</Typography>
                                    <Typography variant='subtitle2'>{item?.questionId?.questions}</Typography>
                                </Box>
                                <Box>
                                    <InputLabel className='mb-1'><Typography variant='caption'>Order</Typography></InputLabel>
                                    <TextField
                                        className='p-0'
                                        value={localValues[item.clientEntityQuestionVenueId] || updatedOrder?.find((question: any) => question?.clientEntityQuestion_venue_id === item?.clientEntityQuestionVenueId)?.displayOrder}
                                        // value={}
                                        sx={{
                                            'input': {
                                                padding: '0px',
                                                maxWidth: '75px',
                                            }
                                        }}
                                        // onChange={(e) => {
                                        //     const val = Number(e.target.value);
                                        //     if (!isNaN(val)) handleOrderChange(item.clientEntityQuestionVenueId, val);
                                        // }}
                                        // onBlur={(e) => {
                                        //     const val = Number(e.target.value);
                                        //     console.log("Value", e.target.value)
                                        //     if (!isNaN(val)) {
                                        //         handleOrderChange(item.clientEntityQuestionVenueId, val);
                                        //     }
                                        // }}
                                        onChange={(e) => {
                                            setLocalValues(prev => ({
                                                ...prev,
                                                [item.clientEntityQuestionVenueId]: e.target.value
                                            }));
                                        }}
                                        onBlur={(e) => {
                                            const val = Number(e.target.value);
                                            if (!isNaN(val) && val >= 1) {
                                                handleOrderChange(item.clientEntityQuestionVenueId, val);
                                            }
                                            // Clear local value after update
                                            setLocalValues(prev => {
                                                const newValues = { ...prev };
                                                delete newValues[item.clientEntityQuestionVenueId];
                                                return newValues;
                                            });
                                        }}


                                        inputProps={{
                                            min: 1,
                                            max: updatedOrder.length,
                                            maxLength: 1,
                                            style: {
                                                textAlign: "center",
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                            },
                                        }}
                                        type='number'
                                    />
                                </Box>
                            </Box>
                        ))}
                </Box>
            ) : (
                <Box ref={printRef}>
                    <Typography className=' fw-bold mb-3' variant='h6'>{venueName} (category order)</Typography>
                    {categorylist?.map((item, index: number) => (

                        <Box id={`category-${item.categoryId}`} sx={{ borderRadius: '10px' }} className='border p-2 mb-2'>
                            <Box className='d-flex align-items-center justify-content-between'>
                                <Typography>{item?.categoryName}</Typography>
                                <Box>
                                    <InputLabel className='mb-1'><Typography variant='caption'>Order</Typography></InputLabel>
                                    <TextField
                                        // sx={{padid÷}}
                                        className='p-0'
                                        value={localCategoryValues[item.categoryId] ?? item.order ?? index + 1} // show 1-based value
                                        sx={{
                                            'input': {
                                                padding: '0px',
                                                maxWidth: '75px',
                                            }
                                        }}
                                        onChange={(e) => {
                                            setLocalCategoryValues(prev => ({
                                                ...prev,
                                                [item.categoryId]: e.target.value
                                            }));
                                        }}
                                        onBlur={(e) => {
                                            const val = Number(e.target.value);
                                            if (!isNaN(val) && val >= 1) {
                                                handleCategoryOrderChange(index, val);
                                            }
                                            // Clear local value after update
                                            setLocalCategoryValues(prev => {
                                                const newValues = { ...prev };
                                                delete newValues[item.categoryId];
                                                return newValues;
                                            });
                                        }} inputProps={{
                                            min: 1,
                                            max: categorylist.length,
                                            maxLength: 1,
                                            style: {
                                                textAlign: "center",
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                            },
                                        }}
                                        type='number'
                                    />
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            )}
            <Box className='d-flex justify-content-center extra'> <Button onClick={() => { handleSaveOrder() }} className='bg-grey text-light whitespace px-5 py-2'>Save</Button></Box>
        </Box>

    )
}

export default SetVenueQuestionOrder
